import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loading",
  "use": "icon-loading-usage",
  "content": "<symbol class=\"load_ellipse\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-loading\">\r\n      <ellipse cx=\"26\" cy=\"10\" rx=\"26\" ry=\"10\" style=\"fill:#ddd;stroke:none;\" />\r\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol